import SubcategoryPreferences from "../components/SubcategoryPreferences";
import {Box, Grid, Typography} from "@mui/material";

const PreferencesPage = ({langChanged}) => {
    return (
        <Box sx={{m: 2}}>
            <Grid container spacing={2}>
                <Grid item>
                    <Typography variant="h6">Subcategories for Quizzes</Typography>
                    <SubcategoryPreferences langChanged={langChanged}/>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PreferencesPage;